module.exports = __webpack_public_path__ + "img/0010.904aaa6e.png";